import { USER_TYPE } from 'app/ducks/auth/types'

// Master switch of the MCP server (the AI assistant connector: Claude, ChatGPT, ...). Seeded off in every
// tenant by amsm-backend
// hall/feature_flags/migrations/0007_seed_mcp_server_access_flag.py — see
// docs/FEATURE_FLAGS.md. The backend checks it too: with the flag off, every
// /backend/mcp/api/* endpoint answers 404, which the pages below show as
// "not available" (so a hard reload, before the flags have loaded, never
// bounces the user to a 404 route).
export const MCP_FLAG = 'mcp_server_access'

// Who sees the "Conectar assistente de IA" page and its menu entries. Mirrors
// SETUP_MIN_USER_TYPE in amsm-backend hall/mcp_server/api_views.py.
export const MCP_SETUP_ROLES = [USER_TYPE.MANAGER, USER_TYPE.ADMINISTRATOR]

export const MCP_SETUP_PATH = '/integracoes/assistente-ia'

// The "Uso do MCP" analytics page: every user's tool calls, so administrators
// only. Mirrors USAGE_MIN_USER_TYPE in amsm-backend hall/mcp_server/api_views.py.
export const MCP_USAGE_ROLES = [USER_TYPE.ADMINISTRATOR]

// Under the setup page rather than /mcp-usage, for the same reason as the
// consent page below.
export const MCP_USAGE_PATH = '/integracoes/assistente-ia/uso'

// The OAuth consent page. Not under /mcp: on tenants where the app and the
// API share a host, the reverse proxy sends every /mcp/* path to the MCP
// server. Must match the path amsm-backend's `authorize_view` redirects to.
export const MCP_AUTHORIZE_PATH = '/integracoes/assistente-ia/autorizar'

// AI assistants the setup page has step-by-step instructions for. The
// connection itself is client-agnostic: any MCP client with OAuth 2.1, PKCE
// and dynamic client registration works, and the consent page names
// whichever client asked.
export const ASSISTANTS = {
  claude: {
    label: 'Claude',
    settingsUrl: 'https://claude.ai/settings/connectors',
  },
  chatgpt: {
    label: 'ChatGPT',
    settingsUrl: 'https://chatgpt.com/#settings/Connectors',
  },
}

// The OAuth parameters `authorize_view` forwards in the query string, passed
// back to the API untouched (it re-validates them).
export const FLOW_PARAMS = [
  'client_id',
  'redirect_uri',
  'code_challenge',
  'state',
  'scope',
  'resource',
  'redirect_uri_provided_explicitly',
]

export const isNotAvailable = (error) => error?.response?.status === 404
